import * as actionTypes from "./actionTypes";
import {
  getAssetsDiscountsSummaryAPI,
  deleteAssetsDiscountsSummaryAPI,
} from "@icarius-connection/api";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getLocalizedString, getErrorStringFromServerError } from "@icarius-localization/strings";

const errorHandler = (e, dispatch) => {
  let errorString = "";
  switch (e.response?.data?.status) {
    case "INVALID_DATA":
    case "VALIDATION_ERROR":
      errorString = getLocalizedString("validationError");
      break;
    case "DUPLICATED_DATA":
      errorString = getLocalizedString("indexWithSamePeriodAlreadyExists");
      break;
    case "IN_USE":
      errorString = getLocalizedString("cannotDeletePeriodBecauseItIsInUse");
      break;
    default:
      errorString = getErrorStringFromServerError(e);
      break;
  }
  dispatch(openSnackbarAction({ msg: errorString, severity: "error" }));
}

export const getAssetsDiscountsSummaryAction = (type, show, code) => async (dispatch) => {
  dispatch({ type: actionTypes.GET });
  try {
    let response = await getAssetsDiscountsSummaryAPI(`?payrollType=${type}&showConceptsPerSociety=${show}${code ? `&code=${code}` : ''}`);

    let data = response.data && response.data.data;
    let payrollTypes = response.data && response.data.payrollTypes;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.GET_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.GET_FULFILLED,
      payload: { data, payrollTypes },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};

export const deleteAssetsDiscountsSummaryAction = (dataToSend) => async (dispatch) => {
  dispatch({ type: actionTypes.DELETE });
  try {
    let response = await deleteAssetsDiscountsSummaryAPI(dataToSend);
    let data = response.data && response.data.data;
    let payrollTypes = response.data && response.data.payrollTypes;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.DELETE_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.DELETE_FULFILLED,
      payload: { data, payrollTypes },
    });

    dispatch(openSnackbarAction({ msg: getLocalizedString("earningsDeletedSuccessfully"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.DELETE_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};